<div id="app" class="app" appSignoutBeforeUnload   [dir]="(settings.rtl) ? 'rtl' : 'ltr'">
    <router-outlet></router-outlet>    
    <div id="app-spinner" [class.hide]="!settings.loadingSpinner">
        <mat-spinner color="accent"></mat-spinner>
    </div>     
</div>